import React, { useState, useEffect } from 'react';
import { Microphone, SpeakerHigh, Translate } from '@phosphor-icons/react';

const SCRIPT = [
  { lang: 'EN', side: 'left', text: 'We need to pour the footings tomorrow at 7am.', flag: '🇺🇸' },
  { lang: 'ES', side: 'right', text: 'Necesitamos colar los cimientos mañana a las 7am.', flag: '🇲🇽', spoken: true },
  { lang: 'ES', side: 'right', text: '¿Cuántas varillas llevan las zapatas?', flag: '🇲🇽' },
  { lang: 'EN', side: 'left', text: 'How many rebar go in the footings?', flag: '🇺🇸', spoken: true },
  { lang: 'EN', side: 'left', text: 'Four #5 bars each way, tied on 12-inch centers.', flag: '🇺🇸' },
  { lang: 'ES', side: 'right', text: 'Cuatro varillas #5 en cada dirección, amarradas a cada 12 pulgadas.', flag: '🇲🇽', spoken: true },
];

export const VoiceTranslatorMock = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setStep((s) => (s >= SCRIPT.length ? 0 : s + 1)), 1800);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="max-w-md mx-auto bg-emerald-950/80 border-2 border-white rounded-2xl p-5 shadow-[6px_6px_0px_#022C22]" data-testid="voice-translator-mock">
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/20">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white/15 border border-white/40 rounded-lg flex items-center justify-center">
            <Translate size={16} weight="bold" className="text-white" />
          </div>
          <span className="text-sm font-black uppercase tracking-wider text-white">Live on the job site</span>
        </div>
        <span className="flex items-center gap-1.5 text-[10px] font-bold text-emerald-200 uppercase">
          <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" /> Recording
        </span>
      </div>
      <div className="space-y-2.5 min-h-[290px]">
        {SCRIPT.slice(0, step).map((m, i) => (
          <div key={i} className={`flex ${m.side === 'right' ? 'justify-end' : 'justify-start'}`} style={{ animation: 'fadeSlideIn .4s ease both' }}>
            <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 border-2 ${m.side === 'right' ? 'bg-white text-emerald-900 border-emerald-200 rounded-br-sm' : 'bg-emerald-700 text-white border-emerald-500 rounded-bl-sm'}`}>
              <div className="flex items-center gap-1.5 mb-0.5">
                <span className="text-[10px] font-black opacity-70">{m.flag} {m.lang}</span>
                {m.spoken ? (
                  <SpeakerHigh size={12} weight="fill" className={m.side === 'right' ? 'text-emerald-600' : 'text-emerald-200'} />
                ) : (
                  <Microphone size={12} weight="fill" className={m.side === 'right' ? 'text-emerald-600' : 'text-emerald-200'} />
                )}
              </div>
              <p className="text-sm font-medium leading-snug">{m.text}</p>
            </div>
          </div>
        ))}
        {step < SCRIPT.length && (
          <div className={`flex ${SCRIPT[step]?.side === 'right' ? 'justify-end' : 'justify-start'}`}>
            <div className="flex items-center gap-1 bg-white/10 border border-white/20 rounded-full px-3 py-2">
              {[0, 1, 2].map((d) => (
                <span key={d} className="w-1.5 h-1.5 rounded-full bg-white/70 animate-bounce" style={{ animationDelay: `${d * 0.15}s` }} />
              ))}
            </div>
          </div>
        )}
      </div>
      <style>{`@keyframes fadeSlideIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};
